import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "page",
  id: "page"
};
const _hoisted_2 = {
  class: "section-md bg-transparent",
  style: {
    "opacity": "1"
  }
};
const _hoisted_3 = {
  class: "container"
};
const _hoisted_4 = {
  class: "row row-30 row-xl-55 row-xxl-100 justify-content-center"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  class: "col-md-3 col-xl-3"
};
const _hoisted_7 = {
  class: "list list-divided list-divided-sm big"
};
const _hoisted_8 = {
  class: "list-item"
};
const _hoisted_9 = {
  class: "list-item"
};
const _hoisted_10 = {
  class: "list-item"
};
const _hoisted_11 = {
  class: "list-item"
};
import { ref, onMounted, watch, computed } from 'vue';
import { useRoute } from 'vue-router';
import { aboutInfo, aboutInfo1 } from '@/api/about';
import { bannerList as bannerListHttp } from '@/api/home';
export default {
  __name: 'about',
  setup(__props) {
    const route = useRoute();
    const typeQuery = ref('introduction');
    const info = ref(null);
    const honourList = ref([]);
    const scrollbarRef = ref(null);
    const aboutContent = ref(null);
    watch(() => route.query.type, () => {
      getData();
    }, {
      deep: true
    });
    const path = computed(() => {
      return process.env.VUE_APP_BASE_ADDRESS;
    });

    // 顶部图片
    const bg = ref('');
    const getBanner = async () => {
      const data = await bannerListHttp({
        type: 'about'
      });
      if (data?.length > 0) {
        for (const item of data) {
          if (!item.src.startsWith('http')) item.src = path.value + item.src;
        }
        bg.value = data[0]?.src;
      }
    };
    const getData = async typeSrc => {
      const type = typeSrc ? typeSrc : route?.query?.type || 'introduction';
      typeQuery.value = type;
      scrollbarRef.value?.setScrollTop(0);
      const data = await aboutInfo1({
        type
      });
      aboutContent.value?.classList.add('animated', 'fadeOut');
      setTimeout(() => {
        // if (type === 'honour') {
        //     honourList.value = data;
        // } else {
        //     info.value = data;
        // }
        info.value = data;
        aboutContent.value?.classList.remove('fadeOut');
        aboutContent.value?.classList.add('fadeIn');
      }, 100);
    };
    onMounted(async () => {
      getBanner();
      getData();
    });
    return (_ctx, _cache) => {
      const _component_Preload = _resolveComponent("Preload");
      const _component_Header = _resolveComponent("Header");
      const _component_router_link = _resolveComponent("router-link");
      const _component_Footer = _resolveComponent("Footer");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Preload), _createElementVNode("div", _hoisted_1, [_createVNode(_component_Header, {
        title: "关于冀华",
        bg: bg.value
      }, null, 8, ["bg"]), _createElementVNode("section", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
        class: "col-md-8 row",
        ref_key: "aboutContent",
        ref: aboutContent,
        "data-animate": "{\"class\":\"fadeInUpBig\"}"
      }, [_createElementVNode("h5", {
        innerHTML: info.value
      }, null, 8, _hoisted_5)], 512), _cache[6] || (_cache[6] = _createElementVNode("div", {
        class: "col-md-1"
      }, null, -1)), _createElementVNode("div", _hoisted_6, [_cache[5] || (_cache[5] = _createElementVNode("h3", {
        class: "text-primary"
      }, "关于冀华", -1)), _createElementVNode("ul", _hoisted_7, [_createElementVNode("li", _hoisted_8, [_createElementVNode("a", {
        class: _normalizeClass(["link link-arrow", typeQuery.value == 'introduction' ? 'link-hover' : '']),
        onClick: _cache[0] || (_cache[0] = $event => getData('introduction'))
      }, "冀华简介", 2)]), _createElementVNode("li", _hoisted_9, [_createElementVNode("a", {
        class: _normalizeClass(["link link-arrow", typeQuery.value == 'organization' ? 'link-hover' : '']),
        onClick: _cache[1] || (_cache[1] = $event => getData('organization'))
      }, "组织结构", 2)]), _createElementVNode("li", _hoisted_10, [_createElementVNode("a", {
        class: _normalizeClass(["link link-arrow", typeQuery.value == 'honour' ? 'link-hover' : '']),
        onClick: _cache[2] || (_cache[2] = $event => getData('honour'))
      }, "资质荣誉", 2)]), _createElementVNode("li", _hoisted_11, [_createElementVNode("a", {
        class: _normalizeClass(["link link-arrow", typeQuery.value == 'service' ? 'link-hover' : '']),
        onClick: _cache[3] || (_cache[3] = $event => getData('service'))
      }, "服务理念", 2)])]), _createVNode(_component_router_link, {
        class: "btn btn-block",
        to: "/contact-us"
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("联系我们")])),
        _: 1
      })])])])]), _createVNode(_component_Footer)])], 64);
    };
  }
};